import { Component, Input, OnInit, EventEmitter, Output, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Lightbox } from 'ngx-lightbox';
import { IAlbum } from '../../../../core/models/patient/patient';
import { PatientAdvancedDirective } from '../../../../core/models/patient/patientAdvancedDirective';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-advanced-directives',
  templateUrl: './advanced-directives.component.html',
  styleUrls: ['./advanced-directives.component.scss']
})
export class AdvancedDirectivesComponent implements OnInit {
  isEdit = false;

  @Input() advancedDirectives: PatientAdvancedDirective[];
  @Input() isParams = false;
  @Input() editEnable: boolean = true;
  @Output() toggleEditEvent = new EventEmitter();
  private previewBoxDialogBox: MatDialogRef<TemplateRef<any>>;
  @ViewChild('previewBox', { static: false }) previewBox: TemplateRef<any>;
  previewBoxDialogBoxUrl;
  previewBoxDataType;
  displayedColumnsTrial: string[] = [
    "no", "name", "EffectiveFrom", "EffectiveTo", "DirectivesDoc", "DirectiveActionButton"
  ];

  constructor(private lightbox: Lightbox,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private loaderService: WindowLoaderService,
    private patientService: PatientService,
    private changeDetectorRefs: ChangeDetectorRef,
  ) { }

  ngOnInit() {
  }

  toggleEdit(advancedDirective: PatientAdvancedDirective) {
    if (advancedDirective) {
      this.toggleEditEvent.emit(advancedDirective);

    } else {
      this.toggleEditEvent.emit(new PatientAdvancedDirective());
    }
  }

  deleteAdvancedDirective(advancedDirective: PatientAdvancedDirective, index: number) {
    this.loaderService.show();
    const advancedDirectiveForData = new FormData();
    advancedDirectiveForData.append('PatientId', advancedDirective.patientId.toString());
    advancedDirectiveForData.append('Id', advancedDirective.id.toString());
    advancedDirectiveForData.append('Type', advancedDirective.type.toString());
    var nowDate = new Date();
    var date = (nowDate.getMonth() + 1) + '/' + nowDate.getDate() + '/' + nowDate.getFullYear();
    advancedDirectiveForData.append('EffectiveFrom', date);
    advancedDirectiveForData.append('Active', 'false');

    this.patientService.updatePatientAdvancedDirective(advancedDirectiveForData).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.advancedDirectives.splice(index, 1);
          this.loaderService.hide();
          this.changeDetectorRefs.detectChanges();
        } else
          console.error(res);
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      });
  }

  openLightbox(url): void {
    this.previewBoxDialogBox = this.dialog.open(this.previewBox, {
      panelClass: `dialog--popup`,
      width: '600px',
      disableClose: false,
    });
    // this.previewBoxDialogBoxUrl = url;
    this.previewBoxDialogBoxUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.previewBoxDataType = url.split(".").slice(-1)[0];
  }

  onFileSelected() { }

  checkExt(filename) {
    if ((typeof filename) == 'string')
      return filename.split('.').pop();

    return 'blob';
  }
  closeDialogBox() {
    this.previewBoxDialogBox.close();
  }
}
